import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useVideoPlayerTranslations = (): Record<string, string> => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      'video.status_processing': t('video.status_processing'),
      'video.unavailable': t('video.unavailable'),
    }),
    [t],
  );
};

export default useVideoPlayerTranslations;
